(function (app) {
    
    app.provider("marketingTrackerConstantContactApi",
        [
            function () {
                this.$get = [
                    "marketingTrackerApiGateway", function (marketingTrackerApiGateway) {
                        var service = {};

                        service.getCampaigns = function () {
                            return marketingTrackerApiGateway.getArray("/ConstantContact/Campaigns");
                        };

                        service.getCampaignById = function (campaignId) {
                            return marketingTrackerApiGateway.get("/ConstantContact/Campaigns/" + campaignId);
                        };

                        service.getContactsByCampaignId = function (campaignId) {
                            return marketingTrackerApiGateway.get("/ConstantContact/Campaigns/" + campaignId + "/Contacts");
                        };

                        service.getActivityByCampaignIdAndType = function (campaignId, filter) {
                            return marketingTrackerApiGateway.get("/ConstantContact/Campaigns/" + campaignId + "/Tracking/" + filter);
                        };

                        service.getActivityByCampaignId = function (campaignId) {
                            return marketingTrackerApiGateway.get("/ConstantContact/Campaigns/" + campaignId + "/Tracking/");
                        };

                        service.getActivityByContactId = function (contactId) {
                            return marketingTrackerApiGateway.get("/ConstantContact/Contacts/" + contactId + "/Activity");
                        };

                        service.getContactById = function (contactId) {
                            return marketingTrackerApiGateway.get("/ConstantContact/Contacts/" + contactId);
                        };

                        service.getHasToken = function () {
                            return marketingTrackerApiGateway.get("/ConstantContact/Token/HasToken");
                        };

                        service.removeToken = function () {
                            return marketingTrackerApiGateway.delete("/ConstantContact/Token/User");
                        };

                        service.postToken = function (tokenModel) {
                            return marketingTrackerApiGateway.post("/ConstantContact/Token", tokenModel);
                        };

                        service.postConnect = function () {
                            return marketingTrackerApiGateway.post("/ConstantContact/Token/Connect", null);
                        };

                        service.syncContacts = function () {
                            return marketingTrackerApiGateway.get("/ConstantContact/Contacts/Sync");
                        };

                        service.getContactsByListId = function (listId) {
                            return marketingTrackerApiGateway.get("/ConstantContact/ContactLists/" + listId);
                        };

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line